<template>
    <div id="PatientHistorySearch">
    <Subtitle  v-bind:ServiceID="this.AppServiceID">
       <template v-slot:header>
        <i class="fa fa-user-plus"></i><b>View User EDS Allocation:</b>
      </template> 
    </Subtitle>
    <Card>
    <CardBody>
    <p>View User EDS Allocation is an Administration action. Any change in this section will affect the web application and its access level. All transactions are monitored, logged and reviewed.
    </p> 
    </CardBody>
    </Card> 
    <!-- <b-modal modal-class="test-modal fade"
      id="phModal"   v-model="ShowStd"  no-close-on-esc no-close-on-backdrop hide-header-close
      ok-variant cancel-variant hide-footer
     header-class="PopUpHeader" 
      :body-bg-variant=PopUpVar.bodyBgVariant
      :body-text-variant=PopUpVar.bodyTextVariant
      :footer-bg-variant=PopUpVar.footerBgVariant
      :footer-text-variant=PopUpVar.footerTextVariant> 
     <AddEDSStandard v-if="ShowStd==true" @stddone="closestdModal" @loadmainedstbl="LoadEdstbl"></AddEDSStandard>
     <template slot="modal-header"   slot-scope="{ close }"> 
        <div>
        <small class="PopUpTitle w-100 text-left ml-2"> Add EDS Criteria</small>
      </div> 
      <div v-show="Button=='Add'"></div>
    </template>  
</b-modal> -->

<b-modal  
      id="criteriamodel"   modal-class="criteriamodel fade"   v-model="ShowCriteria"  no-close-on-esc no-close-on-backdrop hide-header-close
      ok-variant cancel-variant hide-footer
     header-class="PopUpHeader" 
      :body-bg-variant=PopUpVar.bodyBgVariant
      :body-text-variant=PopUpVar.bodyTextVariant
      :footer-bg-variant=PopUpVar.footerBgVariant
      :footer-text-variant=PopUpVar.footerTextVariant> 
     <ViewCriteria v-if="ShowAdd" @criteriadone="closeCriModal" :tblRow="tblrow" :mode="mode"></ViewCriteria>
    
     <template slot="modal-header"   slot-scope="{close}"> 

      
        <div class="col-sm-8">
        <small class="PopUpTitle float-left ml-2">{{Poptitle}} EDS Criteria</small>
        </div>
        <div class="col-sm-4">
        <button  v-on:click="ShowCriteria=false" type="button" class="ml-1 btn btn-primary btn-sml float-right"><i class="far fa-times-circle"></i>Close</button>
        </div>   
     
    </template>  
</b-modal>

     <form class="card  p-3 mb-1" id="SearchForm"> 


<div class="row p-2">
  <!-- {{ GetUserType[0].roleName }} -->
   <!-- {{ UserType }} -->
  <div> 
        <v-client-table  :columns="columns"  :data="TblData" :options="options">  
          <div slot="beforeTable"  class="form-group row VueTables_Adduser Maintitle mr-1 ml-1"> 
          <div class="col-4 float-left mt-1 pl-1">
            <strong>EDS Drugs And Criteria</strong>
          </div>  
        </div> 
      <span class="pointer" v-on:click="View(props.row)" slot="view" slot-scope="props" > <i class="far fa-question-circle"></i></span>  
     
    </v-client-table>
  </div>
</div>
</form>
 
    </div>
    </template> 
    <script>
    import Vue from 'vue'; 
    import {mapGetters} from 'vuex'
    import moment from 'moment'
    import axios from 'axios' 
    import Datepicker from 'vuejs-datepicker';
    import LayoutDefault from '@/Common/Default/DefaultLayout.vue'; 
    import Subtitle from '@/Common/Default/SubTitle.vue'; 
    import Modal from '@/Common/ModelPop.vue';
    import Card from "@/Common/Card.vue";
    import CardBody from "@/Common/CardBody.vue";
    import TileNote from "@/Common/TileNote.vue";
    import { PopUpVariant } from '@/Common/Default/PopUpVariant';
    import { request } from 'http';
    import AddEDSStandard from '@/components/DPEBB/Administrator/AddEDSStandard.vue'
    import ViewCriteria from '@/components/DPEBB/Administrator/ViewUserCriteria.vue'
    import Vuelidate from 'vuelidate'
    import {helpers, required, minLength, sameAs, not, maxLength, numeric, integer, between} from 'vuelidate/lib/validators'
    import EditEDSStandard from '@/components/DPEBB/Administrator/EditEDSStandard.vue';
 
    
    Vue.use(Vuelidate);
    export default  {
      props: {
          Type: '1'
      },
      name: 'ViewEDS',
      data: function () {
        return {
            tblrow:'',
            mode:'',
            Poptitle: 'View',
            Button: 'View',
            PopUpVar:PopUpVariant,
            ShowCriteria: false,
            ShowAdd :false,
            ShowEdit: false,
            ShowStd: false,
            TblData: [],
            UserType: '',
            columns: ['view','usertype' , 'dosage','din', 'eds','effectivedate','expirydate','backdating','bkunit', 'bklength', 'singledin','createdby','modifyby'],
    
    options: {
    texts:{
      //count:"Showing {from} to {to} of {count} records|{count} records|One record",
      first:'First',
      last:'Last',
      //limit:"Records:",
      //page:"Page:",
      //noResults:"No Eds Record Found",
      filterBy:"Filter by {column}",
      loading:'Loading...',
      defaultOption:'Select {column}',
      columns:'Columns'
    },
    headings: { 
      view: 'View Criteria',
      edit: 'Edit EDS',
      usertype: 'User Type',
      dosage: "Dosage",
      din: "Din",
      eds: "Brand/Generic name",
      effectivedate: "Effective Date",
      expirydate: "Expiry Date",
      createdby: "Created By",
      modifyby: "Modify By",
      backdating: "Back Dating",
      bkunit: "Unit",
      bklength:"Length",
      singledin:"Added By Multiple Dins"

    },

    responseAdapter({data}) {
      return {
        data: formatData,
        count: data.length
      };
    },
    summary: false,
    caption: false,
    perPage:15,
    perPageValues:[10,15,25],    
    dateColumns:['effectivedate','expirydate'],
    footerHeadings: false,
    filterable: true,

    // listColumns: {
    //   claimtype: [
    //     {id: "CL",
    //     text: "Claim"},
    //     {id: "PA",
    //     text: "Prior Approval"}
    //   ]
    // },

    templates: {
      effectivedate(h, row) {         
        return moment(row.effectivedate,"YYYY-MM-DD").format('YYYY/MM/DD');  
      },  
      expirydate(h, row) {         
        return moment(row.expirydate,"YYYY-MM-DD").format('YYYY/MM/DD');  
      },
      singledin(h, row) {
      if(row.singledin ==true)
            return "NO"
        else
        return  "YES"
        },
        backdating(h, row) {
      if(row.backdating ==true)
            return "Yes"
        else
        return  "No"
        },
    },


    pagination: {
     
      nav: 'scroll',
      chunk: 15,
      show:true,
      dropdown: false,
      edge: false,
      align: "center",
      nav: "fixed"
    },

    sortable: ['usertype' , 'dosage','din', 'eds','effectivedate','expirydate','backdating','bkunit', 'bklength', 'singledin','createdby','modifyby'],
    filterable: ['usertype' , 'dosage','din', 'eds','effectivedate','expirydate','backdating','bkunit', 'bklength', 'singledin','createdby','modifyby'],
   
    sortIcon: {
            base : 'fas',
            is: 'fa-sort',
            up: 'fa-sort-up',
            down: 'fa-sort-down'
    },
  },
        }
    },        
    filters: {
          moment: function (date) {
            return moment(date,"YYYY-MM-DD").format('YYYY/MM/DD');
          },
          stringify(value) {
            return JSON.stringify(value, null, 2)
          }  
        }, 
    
    methods: 
    {
      showMsgBox(msg,data,MethodNo,done) {
           var vm  = this;
          this.boxTwo = ''
          this.$bvModal.msgBoxConfirm(msg, {
          title: 'Please Confirm',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          cancelVariant: 'default',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true, 
        })
          .then(value => {
            this.boxTwo = value
            ////console.log(value)
            if(value)
            {
              if(MethodNo ==2)
               {
                 done()
                 //vm.DelConfirm = this.boxTwo;
               }
               if(MethodNo ==1)
                this.DeleteEdsCriteria(data);
            }
          })
          .catch(err => {
            // An error occurred
          })
      },

        DeleteEdsCriteria(rowdata)
        {
          //console.log('row data' + rowdata.id)
              var vm = this;
              vm.searched = false;
              var params = new URLSearchParams();
              //params.append('usergroupid', this.tblRow.id);
              params.append('id', rowdata.id);
              axios.delete("SaskHealthApi/Codes/DeleteEdsCriteria", {headers: { Authorization: "Bearer " + localStorage.access_token },params,})
              .then(function (response) {
                if(response.data == true)
                {
                  vm.showMsg('Eds and Criteria successfully deleted' , '', 'Eds Criteria message')
                  vm.loadTable();
                }
                else
                vm.showMsg('Criteria was not deleted, please contact system administrator' , '', 'Eds Criteria message')
              })
              .catch(function (er) {
                //console.log(' error' + er )     
              
                vm.showMsg('Criteria was not deleted, please contact system administrator' , '', 'Eds Criteria message')
                        //console.log(er)
                
                    }).then(function () {

                    }); 
        },

      LoadEdstbl(){
        this.loadTable();
      },
        View(Rowdata){     
            this.mode='View';
            this.Poptitle="View" 
            ////console.log('dbkey = ' + Rowdata.dbkey)      
            this.tblrow= Rowdata;            
            this.ShowStd=false ;
            this.ShowAdd = true;
            this.ShowEdit = false;
            this.ShowCriteria = true;           
            },
        Edit(Rowdata){     
          this.mode='Edit';
          this.Poptitle="Edit" 
          ////console.log('dbkey = ' + Rowdata.dbkey)      
          this.tblrow= Rowdata;            
          this.ShowStd=false ;
          this.ShowAdd = false;
          this.ShowEdit = true;
          this.ShowCriteria = true;   
          this.LoadEdstbl();        
          },
        closestdModal(value) { 
          //console.log('at close model: ' + value)
            this.DeleteEDSClose(value);
            this.ShowStd = false;
            this.ShowAdd = false;
            this.ShowEdit = false;
            this.loadTable();
            
        },
        closeCriModal() { 
          //console.log('heee')
            this.ShowCriteria = false;
            this.loadTable();
        },



    loadTable()
    {

    var vm = this;
    vm.searched = false;
    var params = new URLSearchParams();
     //params.append('usergroupid', 1)//this.AppServiceID);
    //axios.get('SaskHealthApi/Code/GetUsersEDSAllocation', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token , params})
    axios.get('SaskHealthApi/Codes/GetAllEDSAllocation?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }}) //,params})
   .then(function (response) {
         vm.TblData=response.data; 
         //console.log(response.data);
      })
      .catch(function (er) {
          //console.log(er)
      });
    },
    
    showMsg(msg,data,Title) {
        this.boxTwo = ''
        this.$bvModal.msgBoxOk(msg, {
        title: Title,
        size: 'md',
        buttonSize: 'md',
        okVariant: 'danger',
        okTitle: 'Close',
        footerClass: 'p-2',
        hideHeaderClose: true,
        hideHeaderCancel: true,
        centered: true,
      })
        .then(value => {


          this.boxTwo = this.msg;
          if(value)
          {

          }
        })
        .catch(err => {
          // An error occurred
        })
    
    },
},


    components: { 
            Card,
            CardBody,
            TileNote ,
            Datepicker,
            AddEDSStandard,
            Subtitle,
            Modal,
            ViewCriteria,
            EditEDSStandard,
        },
      computed:{
          UserName(){
              return !this.$store.getters.GetCurrentUser ? false : this.$store.getters.GetCurrentUser;
          },
          AllAppLevel(){
              return this.$store.getters.GetAllApplevel;
          }, 
      },
    
      created: function() {         
       
        this.AppServiceID = this.$store.getters.GetDPEBBServiceID; 
        this.DateFormat = this.$store.getters.GetDateFormat;  
        this.$emit('update:layout', LayoutDefault);  
        //console.log(this.GetUserType);
        //this.GetUserType();
        this.loadTable();
      },
    
      beforeCreate: function() {  
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDPEBBServiceID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDPEBBServiceID);
      },
    
      mounted: function () { 
        //console.log(this.GetUserType[0]);
      },
    }
     
    
    </script>
    
    <style scopped>
    custom-control-label {
      position: relative;
      margin-bottom: 0;
  }
   
  label {
      display: inline-block;
      margin-bottom: .5rem;
  }
     .row.no-gutter [class*='col-']   {
       padding-right:1px;
       
     }
     .list-group-item {
        position: relative;
        display: block;
        padding: 0px 15px;
        margin-bottom: -1px;
        border: 1px solid #ddd;
        background-color: blue;
        line-height: 1em
    }
    .col-lg-1>div {background-color:#ddd;}
    
    #docimg {
       
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50; 
    }
    #line {
      border-top:1px solid   rgba(7, 14, 109, 0.25);
    }
    
.criteriamodel .modal {
  padding: 0 !important;
  padding-left: 0px !important;
  overflow-y: scroll;
}

.test-modal .modal {
  padding: 0 !important;
  padding-left: 0px !important;
  overflow-y: scroll;
}

.test-modal .modal-dialog {
  max-width: 100%;
  height: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  z-index: 100000;
  padding-right: 0px !important;
  padding-left: 0px !important;
}

.criteriamodel .modal-dialog {
  max-width: 100%;
  height: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  z-index: 100000;
  padding-right: 0px !important;
  padding-left: 0px !important;
}

.modal-open {
  padding: 0 !important;
  padding-left: 0px !important;
  overflow-y: scroll;
}

#phModal {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

#criteriamodel {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
    </style>